export default __webpack_public_path__ + "static/media/origo.f1a665a0.jpg";